<template>
  <div>
    <b-navbar toggleable="lg" type="light">
      <div class="container">
        <b-navbar-brand @click="navHome()" :title="name">
          <img
              style="height: 40px; margin: 8px 0;"
              :src="require(`@/assets/images/${getSkin()}`)"/>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav v-if="$auth.check()">
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/dashboard" exact>Dashboard</b-nav-item>
            <b-nav-item to="/advisors">Advisors</b-nav-item>
            <b-nav-item to="/entrepreneurs">Entrepreneurs</b-nav-item>
            <!-- <b-nav-item to="/meetings">Upcoming</b-nav-item> -->
            <!-- <b-nav-item to="/reviews">Reviews</b-nav-item> -->
            <b-nav-item to="/resources">Resources</b-nav-item>

            <b-nav-item-dropdown right v-if="$auth.user().roles == 'admin'">
              <template slot="button-content">Admin</template>

              <b-dropdown-item to="/admin">Dashboard</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/admin/users">Users</b-dropdown-item>
              <b-dropdown-item to="/admin/meetings">Meetings</b-dropdown-item>
              <b-dropdown-item to="/admin/reviews">Reviews</b-dropdown-item>
              <b-dropdown-item to="/admin/resources">Resources</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right>
              <template slot="button-content">
                {{ $auth.user().first_name }}
                {{ $auth.user().last_name }}
              </template>

              <b-dropdown-item to="/profile/edit">Edit Profile</b-dropdown-item>
              <b-dropdown-item to="/calendar">Edit Schedule</b-dropdown-item>
              <b-dropdown-item
                @click="$auth.logout({
                  makeRequest: true,
                  redirect: '/login'
                })"
              >
                Sign Out
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  data() {
    return {
      name: process.env.VUE_APP_TITLE,
    }
  },
  mounted() {
    window.document.title = this.name
  },
  methods: {
    getSkin() {
      switch (process.env.VUE_APP_SKIN) {
        case 'wedi':
          return 'logo-wedi.png'
        case 'fivenomics':
        default:
          return 'logo-fivenomics.svg'
      }
    },
    navHome() {
      switch (process.env.VUE_APP_SKIN) {
        case 'wedi':
          return this.$router.push({name: 'dashboard'})
        case 'fivenomics':
        default:
          if (this.$auth.check())
            return this.$router.push({name: 'dashboard'})
          return this.$router.push({name: 'welcome', query: {r: '1'}})
      }
    }
  }
}
</script>
